// Wording of the "Dateien" walkthrough. The twin of de/help/files.js — same steps, same claims.
export default {
  title: "Files",
  section: {
    FileBrowser: "Files",
    ProjectDetail: "Project",
    SettingsOverview: "Settings",
  },
  related: "Connections",
  step: {
    intro: {
      text: "This is where you find every file of your company in one place. Each file still belongs to its record, a project or a customer for example.",
    },
    places: {
      text: "On the left is every place that holds files. The number beside it says how many there are below it.",
    },
    search: {
      text: "The search finds folders and files across the whole company. It looks at the tags as well.",
    },
    "due-filter": {
      text: "This filter shows only files that have expired, are running out, or are still valid.",
    },
    storage: {
      text: "The bar shows how much storage your company uses. Once it is full, Lewara accepts no further file.",
    },
    place: {
      text: "A place lists the records that carry files. Each row says how many are on that record.",
    },
    record: {
      text: "The path shows where you are and takes you back with one click. Below it stands what this folder holds.",
    },
    list: {
      text: "Folders come first, the files below them. A click on a column heading sorts the list.",
    },
    upload: {
      text: "Upload puts a file on this record directly. You can also drag files onto the list.",
    },
    owner: {
      text: "This link opens the record itself, here the project with everything else that hangs on it.",
    },
    "due-column": {
      text: "Valid until says when a document expires. Its colour changes as the date comes closer.",
    },
    details: {
      text: "A click on a row opens the file: images and PDFs as a smaller preview, everything else in this window. Download gets the original.",
    },
    "details-meta": {
      text: "Tags are what make a file findable. The document date records what the document says, even when it was uploaded later. Valid until sets how long the file is valid and how early Lewara warns.",
    },
    again: {
      text: "This button sits on every page that has an explanation. One click starts it again.",
    },
    "project-files": {
      text: "Files are uploaded on the record itself, here on the project. Under Files you find the same ones again.",
    },
    "notify-documents": {
      text: "Expiring documents are reported by the bell. Here you set how many days ahead it warns.",
    },
    rights: {
      text: "A role's rights decide which places the file browser shows and which of them you may upload to.",
    },
  },
}
